import { render } from "./chooseMovie.vue?vue&type=template&id=e184cd92&scoped=true"
import script from "./chooseMovie.vue?vue&type=script&lang=js"
export * from "./chooseMovie.vue?vue&type=script&lang=js"

import "./chooseMovie.vue?vue&type=style&index=0&id=e184cd92&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e184cd92"]])

export default __exports__